import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ModelGETKnowledge, type IModelGETKnowledgeRequest, type IModelGETKnowledgeResponse } from "./dto/knowledge.dto";

import { KnowledgeRepository } from "./knowledge.repository";


export class KnowledgeService extends BaseService {
  private knowledgeRepository = new KnowledgeRepository(this.api, this.configService);

  async getKnowledgePreset(params: IModelGETKnowledgeRequest): Promise<IModelResponse<ModelGETKnowledge[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelGETKnowledge[]> = {
      data: [],
    };

    try {
      const res = await this.knowledgeRepository.getKnowledgePreset(params);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e: IModelGETKnowledgeResponse) => new ModelGETKnowledge(e))
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems || 0;
        console.log('getKnowledgePreset', params, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeService.name);
    }

    return dataResult;
  }

  async deleteKnowledgePreset(params: string): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.knowledgeRepository.deleteKnowledgePreset(params);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = resData.data
        console.log('deleteKnowledgePreset', params, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeService.name);
    }

    return dataResult;
  }

  async getKnowledgeDetail(id: string): Promise<ModelGETKnowledge | null> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETKnowledge | null = null;

    try {
      const res = await this.knowledgeRepository.getKnowledgeDetail(id);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = new ModelGETKnowledge(resData.data);
        console.log('getKnowledgeDetail', id, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeService.name);
    }

    return dataResult;
  }

  async createKnowledge(data: any): Promise<ModelGETKnowledge | null> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETKnowledge | null = null;

    try {
      const res = await this.knowledgeRepository.createKnowledge(data);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = new ModelGETKnowledge(resData.data);
        console.log('createKnowledge', data, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeService.name);
    }

    return dataResult;
  }

  async updateKnowledge(id: string, data: any): Promise<ModelGETKnowledge | null> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETKnowledge | null = null;

    try {
      const res = await this.knowledgeRepository.updateKnowledge(id, data);
      const resData = res?.data?.value;
      if (resData && $functions.isValidResponse(resData)) {
        dataResult = new ModelGETKnowledge(resData.data);
        console.log('updateKnowledge', id, data, resData.data, dataResult);
      }
    } catch (err: any) {
      const errorMessage = err?.message || err?.response?._data?.message || 'An error occurred';
      $functions.notify.error({
        text: errorMessage
      });
      console.log(err, KnowledgeService.name);
    }

    return dataResult;
  }
}

